// P5 vocabulary — render-time DISPLAY labels for operator-facing screens.
//
// These map a VALUE -> a human-readable LABEL at render time only. They do
// NOT change any underlying union-type value, API field, or comparison: every
// `=== "online"` / `=== "direct"` check elsewhere keeps comparing the raw
// string. This is a display layer, not a rename. Unknown values never throw —
// they fall back to a capitalized/raw form so a new backend value can't crash
// the UI.

function capitalize(s: string): string {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

const STATUS_LABELS: Record<string, string> = {
  online: "Online",
  offline: "Offline",
  degraded: "Degraded",
};

/** Camera status VALUE -> display label (fixes mixed casing). Unknown values
 *  (e.g. "error", "pending", "unprovisioned") return capitalized, never throw. */
export function statusLabel(status: string): string {
  return STATUS_LABELS[status] ?? capitalize(status);
}

const CONNECTION_LABELS: Record<string, string> = {
  agent: "On-site gateway",
  slink_agent: "On-site gateway", // Sprint-10 placeholder — agent variant
  direct: "Direct connection",
  direct_rtsp: "Direct connection",
  onpremise: "On-premise", // Sprint-10 placeholder
};

/** connection_mode VALUE -> display label. Unknown values return the raw value
 *  unchanged, never throw. */
export function connectionLabel(mode: string): string {
  return CONNECTION_LABELS[mode] ?? mode;
}
